const SimplePlusIcon = ({
  color = `var(--Primary-Color-Shade-1)`,
  size = 12,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11V1M1 6H11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SimplePlusIcon;
